import { MessagingPlatform } from '../../../../../../libs/models/src';
import { HierarchicalFolder, HierarchicalLabel } from '../../../models';

export type HierarchicalLabelOrFolder = (
  | HierarchicalLabel
  | HierarchicalFolder
) & {
  platform: MessagingPlatform;
};

export interface LabelsState {
  labels: HierarchicalLabelOrFolder[];
  isFetchLoading: boolean;
}

export interface LabelsActions {
  setInboxLabels: (labels: HierarchicalLabelOrFolder[]) => void;
  setLoadingFetchLabels: (isLoading: boolean) => void;
  getLabelByIdAndEmailAddress: (
    id: string,
    emailAddress: string,
  ) => HierarchicalLabelOrFolder | undefined;
  updateLabel: (
    id: string,
    emailAddress: string,
    data: Partial<HierarchicalLabelOrFolder>,
  ) => void;
  deleteLabel: (id: string) => void;
  createLabel: (
    data: Omit<HierarchicalLabelOrFolder, 'children'>,
    parentId?: string,
  ) => void;
  getLabelNameFromLabelIdsArray: (
    emailAddress: string,
    array?: string[],
  ) => HierarchicalLabelOrFolder | undefined;
  clearLabelsByEmailAddress: (emailAddress: string) => void;
  resetState: () => void;
}

export const INITIAL_LABELS_STATE: LabelsState = {
  labels: [],
  isFetchLoading: false,
};

export type LabelsStore = LabelsState & LabelsActions;
